import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
    en: {
        verify: "Start Verification",
        step: 'Step',
        firstStep: 'First Step',
        secondStep: 'Second Step',
        thirdStep: 'Third Step',
        centerFaceAlignMsg: 'Fit your face in the circle',
        rightFaceAlignMsg: 'Turn your face slightly right',
        leftFaceAlignMsg: 'Turn your face slightly left',
        nextStepMsg: '* Click to see next step',
        faceVerified: 'Face Verified',
        next: 'Next',
        skip: 'Skip',
        bringCardInBox: 'Please bring your card inside the box',
        moveCardUpward: 'Please move your card upwards',
        moveCardDownward: 'Please move your card downwards',
        bringCardInFlash: 'Please bring your card inside the box after torch turns on',
        keepCardInBox: 'Please keep your card inside the box',
        bringBackCardInBox: 'Please bring backside of your card inside the box',
        waitMsg: 'Please Wait...',
        matchingFaces: 'Processing...',
        extractingData: 'Extracting Data...',
        cameraWaitMsg: 'Please wait for the camera to open',
        refreshPageMsg: 'Please refresh the page',
        blurImageMsg: 'Image is Blur, Please move to brighter place',
        uploading: 'Uploading...',
        motherNameMsg: "Please Select Your Mother's Maiden Name",
        pobMsg: 'Please Select Your Place of Birth',
        selectCarefullyMsg: 'Only one attempt allowed',
        selectNameMsg: 'Please select any name',
        selectCityMsg: 'Please select any city',
        mobileNumMsg: 'Enter Mobile Number',
        validMobileMsg: 'Please enter valid mobile number',
        mobileNotVerifiedMsg: 'Mobile Number Not Verified. Try Again.',
        retriesLeft: 'Retries Left: {n}',
        accept: 'Accept',
        cancel: 'Cancel',
        more: 'More',
        less: 'Less',
        retryQuestion: 'Do you want to retry',
        retryRequest: 'Retry',
        yes: 'Yes',
        no: 'No',
        ok: 'Ok',
        yesRetry: 'Yes, retry',
        yesContinue: 'Yes, continue',
        personalDetails: 'Personal Details',
        id: 'ID:',
        name: 'Name:',
        fatherName: 'Father Name:',
        dob: 'Date Of Birth:',
        doi: 'Date Of Issue:',
        doe: 'Date Of Expiry:',
        country: 'Country of Stay:',
        optionalFields: 'Optional Fields',
        mobileNumber: 'Mobile Number',
        undertaking: 'Undertaking / Consent',
        registeredWithCNIC: 'Mobile Number must be registered with your CNIC',
        chooseOptions: 'Choose all options that apply',
        congrats: 'Congratulations',
        accountOpened: 'Your have just opened you bank account',
        selectedAccount: 'Selected Account Type',
        callHelp: 'Call Help',
        finish: 'Finish',
        tryAgain: 'Try Again',
        faceNotMatched: "Your face didn't match with the ID.",
        dataNotExtracted: "Data not Extracted Correctly.",
        nadraNotMatched: "Your ID card info didn't match with the data.",
        infoNotMatched: "Provided information didn't match with the data.",
        mobileNotMatched: "Your mobile number information didn't match with the data.",
        undertakingNotAccepted: "You didn't agree with Terms and Condition.",
        emailAddress: 'Email',
        mailingAddress: 'Mailing Address',
        cardNotVerified: 'Card not verified automatically',
        backFrame: 'Please show backside of your card',
        selectAgent: 'Please Select Agent',
        handOverToAgent: 'Please hand the device over to agent',
        manuallyVerify: 'Do you want to verify manually',
        options: ['I want to use the account for receiving money from abroad.',
                  'I provide services to foreign clients.',
                  'My max cash balance is Rs. 1,000,000.'],
    },
    ur: {
        verify: 'تصدیق شروع کریں',
        step: 'مرحلہ',
        firstStep: 'پہلا مرحلہ',
        secondStep: 'دوسرا مرحلہ',
        thirdStep: 'تیسرا مرحلہ',
        centerFaceAlignMsg: 'اپنے چہرے کو دائرے کے بیچ میں رکھیں',
        rightFaceAlignMsg: 'اس وقت تک دائیں طرف دیکھیں جب تک آپ گھنٹی نہیں سنیں',
        leftFaceAlignMsg: 'اس وقت تک بائیں طرف دیکھیں جب تک آپ گھنٹی نہیں سنیں',
        nextStepMsg: '* اگلا مرحلہ دیکھنے کے لیے کلک کریں',
        faceVerified: 'چہرے کی تصدیق مکمل ہوئی',
        next: 'آگے چلیں',
        skip: 'آگے چلیں',
        bringCardInBox: 'اپنا کارڈ ڈبے کے اندر لائیں',
        moveCardUpward: 'اپنا کارڈ اوپر لائیں',
        moveCardDownward: 'اپنا کارڈ نیچے لائیں',
        bringCardInFlash: 'ٹارچ آن ہونے کے بعد اپنا کارڈ باکس کے اندر لائیں',
        bringBackCardInBox: 'اپنے کارڈ کا پچھلا حصہ ڈبے کے اندر لائیں',
        keepCardInBox: 'اپنا کارڈ باکس کے اندر رکھیں',
        waitMsg: 'انتظار کریں...',
        matchingFaces: 'انتظار کریں...',
        extractingData: 'انتظار کریں...',
        cameraWaitMsg: 'کیمرہ کھلنے کا انتظار کریں',
        refreshPageMsg: 'براہ کرم صفحہ کو ریفریش کریں',
        blurImageMsg: 'تصویر دھندلی ہے، براہ کرم روشن جگہ پر چلے جائیں',
        uploading: 'اپ لوڈ ہو رہا ہے...',
        motherNameMsg: "اپنی والدہ کا آخری نام منتخب کریں",
        pobMsg: 'اپنی پیدائش کا مقام منتخب کریں',
        selectCarefullyMsg: 'صرف ایک کوشش کی اجازت ہے',
        selectNameMsg: 'براہ کرم کوئی نام منتخب کریں',
        selectCityMsg: 'براہ کرم کوئی شہر منتخب کریں',
        mobileNumMsg: 'موبائل نمبر درج کریں',
        validMobileMsg: 'براہ کرم درست موبائل نمبر درج کریں',
        mobileNotVerifiedMsg: 'موبائل نمبر کی تصدیق نہیں ہوئی۔ دوبارہ کوشش کریں۔',
        retriesLeft: 'بقیہ کوششیں: {n}',
        accept: 'قبول کریں',
        cancel: 'منسوخ کریں',
        more: 'مزید',
        less: 'کم',
        retryQuestion: 'کیا آپ دوبارہ کوشش کرنا چاہتے ہیں',
        retryRequest: 'دوبارہ کوشش کریں',
        yes: 'جی ہاں',
        no: 'نہیں',
        ok: 'ٹھیک ہے',
        yesRetry: 'جی ہاں',
        yesContinue: 'جی ہاں',
        personalDetails: 'ذاتی تفصیلات',
        id: 'شناختی کارڈ نمبر:',
        name: 'نام:',
        fatherName: 'والد کا نام:',
        dob: 'تاریخ پیدائش:',
        doi: 'تاریخ اجراء:',
        doe: 'تاریخ تنسیخ:',
        country: 'جائے رہائش:',
        mobileNumber: 'موبائل نمبر',
        undertaking: 'شرائط و ضوابط',
        registeredWithCNIC: 'موبائل نمبر آپ کے شناختی کارڈ نمبر کے ساتھ رجسٹرڈ ہونا لازمی ہے',
        chooseOptions: 'لاگو ہونے والے تمام اختیارات کا انتخاب کریں',
        congrats: 'مبارک ہو',
        accountOpened: 'آپ کا بینک اکاؤنٹ کھول دیا گیا ہے',
        selectedAccount: 'منتخب کردہ اکاؤنٹ',
        callHelp: 'مدد حاصل کریں',
        finish: 'مکمل کریں',
        tryAgain: 'دوبارہ کوشش کریں',
        optionalFields: 'اضافی معلومات',
        faceNotMatched: 'آپ کا چہرہ شناختی کارڈ سے میچ نہیں ہوا۔',
        dataNotExtracted: 'شناختی کارڈ سے درست ڈیٹا نہیں نکل سکا۔',
        nadraNotMatched: 'آپ کے شناختی کارڈ کی معلومات ڈیٹا بیس سے میچ نہیں ہوئیں۔',
        infoNotMatched: 'فراہم کردہ معلومات ڈیٹا بیس سے میچ نہیں ہوئیں۔',
        mobileNotMatched: 'فراہم کردہ موبائل نمبر ڈیٹا بیس سے میچ نہیں ہوا۔',
        undertakingNotAccepted: 'آپ نے شرائط و ضوابط سے اتفاق نہیں کیا۔',
        emailAddress: 'ای میل',
        mailingAddress: 'موجودہ پتہ',
        backFrame: 'برائے مہربانی کارڈ کا پچھلا حصہ دکھایں',
        cardNotVerified: 'کارڈ کی خود کر تصدیق نہیں ہو سکی',
        manuallyVerify: 'کیا آپ تصدیق کرنا چاہتے ہیں؟',
        selectAgent: 'ایجنٹ منتخب کیجیے',
        handOverToAgent: 'Please hand the device over to agent',
        options: ['میں بیرون ملک سے رقم وصول کرنے کے لیے اکاؤنٹ استعمال کرنا چاہتا ہوں۔',
            'میں غیر ملکی گاہکوں کو خدمات فراہم کرتا ہوں۔',
            'میرا زیادہ سے زیادہ نقد بیلنس روپے 1,000,000 ہے۔']
    }
};

export let i18n = new VueI18n({
    locale: "en", // set locale
    fallbackLocale: "ur", // set fallback locale
    messages // set locale messages
});